import ScrollMagic from 'scrollmagic'
import { controller, debug } from '../util/scrollmagic';
import 'debug.addIndicators'

export default class Logo {
  constructor() {
    this.addAnimation();
  }

  addAnimation() {
    this.logoScene = new ScrollMagic.Scene({
      triggerElement: 'body',
      triggerHook: 0,
      offset: 2,
    })
      .setClassToggle('.c-application-header', 'c-header-compact')
      .addTo(controller);

    if(debug) {
      this.logoScene.addIndicators({ name: 'logo' });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/logo.js